module.exports = __webpack_public_path__ + "static/media/online-analytical.b629f376.svg";